import { useRef, useEffect } from 'react';
import { NOW_SHOWING } from '@/config/assets';
import { Play } from 'lucide-react';

export default function NowShowing({ onTrailer }) {
  const ref = useRef(null);
  const f = NOW_SHOWING;

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) e.target.querySelectorAll('.reveal-el').forEach(c => c.classList.add('visible')); }, { threshold: 0.15 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section id="now-showing" data-testid="now-showing" ref={ref} className="py-24 md:py-40 lg:py-48 px-5 md:px-10 lg:px-20 bg-now">
      <p className="reveal-el font-['Cormorant_Garamond'] text-xs tracking-[0.3em] uppercase mb-6" style={{ color: 'var(--gold)' }}>Recent</p>

      <div className="reveal-el grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10 mt-8">
        <div className="md:col-span-5 relative aspect-[2/3] overflow-hidden rounded-sm" style={{ background: '#0C1222' }}>
          {f.image ? (
            <img src={f.image} alt={f.title} className="absolute inset-0 w-full h-full object-contain" />
          ) : (
            <div className="absolute inset-0 flex flex-col items-center justify-center p-8 text-center">
              <p className="font-['Playfair_Display'] italic text-4xl md:text-5xl font-normal leading-tight" style={{ color: 'var(--deep-black)' }}>{f.title}</p>
            </div>
          )}
        </div>

        <div className="md:col-span-6 md:col-start-7 flex flex-col justify-center">
          <h2 className="reveal-el font-['Playfair_Display'] italic text-4xl md:text-5xl lg:text-6xl font-normal leading-tight" style={{ color: 'var(--warm-cream)' }}>{f.title}</h2>
          <p className="reveal-el font-['Cormorant_Garamond'] italic text-lg md:text-xl mt-3" style={{ color: 'var(--ash)' }}>{f.tagline}</p>

          <div className="reveal-el flex items-center gap-3 mt-4 text-xs font-['Inter']" style={{ color: 'var(--ash)' }}>
            <span>as {f.role}</span>
            {f.coStar && <><span className="w-1 h-1 rounded-full" style={{ background: 'var(--gold)', opacity: 0.3 }} /><span>with {f.coStar}</span></>}
            <span className="w-1 h-1 rounded-full" style={{ background: 'var(--gold)', opacity: 0.3 }} />
            <span>Dir. {f.director}</span>
          </div>

          <p className="reveal-el font-['Cormorant_Garamond'] italic text-base mt-6" style={{ color: 'var(--ash)', opacity: 0.6 }}>Coming to streaming soon.</p>

          <div className="reveal-el flex flex-wrap gap-4 mt-8">
            {f.links?.trailer && (
              <button onClick={() => onTrailer && onTrailer({ title: f.title, links: f.links, url: f.links.trailer })} data-testid="now-trailer"
                className="flex items-center justify-center gap-3 px-7 py-3 rounded-full text-lg font-['Inter'] font-semibold tracking-wide transition-all duration-300 hover:bg-white/5 min-w-[200px]"
                style={{ border: '2px solid rgba(201,168,76,0.3)', color: 'var(--gold)' }}>
                <Play className="w-5 h-5" strokeWidth={1.5} />Watch Trailer
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
